import { Container, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import PageBuilder from "./components/pagebuilder";
import SatoriDemo from './satori-demo';
//import { runAllSerializationTests } from './tests/serialization';

const theme = createTheme();

function App() {
  // if (process.env.NODE_ENV === 'development') {
  //   runAllSerializationTests();
  // }
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
        <div className="flex w-[1600px] h-full items-center justify-center">
          <PageBuilder 
            isEmail={false} 
            pageTitle={"Marketing Campaign Tester"} 
            customFields={["{first-name}", "{last-name}", "{membership-type}", "{location}"]}  />
        </div>
    </ThemeProvider>
    // <SatoriDemo />
  );
}

export default App;
